import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RecurrencePreviewOption } from "../../create-poll.type";

@Component({
    selector: 'recurrence-preview',
    templateUrl: 'recurrence-preview.component.html',
    styleUrls: ['./recurrence-preview.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
    ]
})
export class RecurrencePreviewComponent {

    @Input() recurrence: RecurrencePreviewOption;
  
    constructor() {}
}

